import React, { useEffect, useState } from "react";
import { FormikProvider, useFormik, Field, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import { config } from "../CommonUtils/CommonURLS";
import allowNumbersOnly from "../CommonUtils/CommonValidations";
import CommonCardHeader from "../CommonUtils/CommonCardHeader";

export default function EntryOfAdmissionData() {
  const collCode = sessionStorage.getItem("user_id");
  const [courseData, setCourseData] = useState(false);
  const [admissionData, setAdmissionData] = useState(false);

  // ******** VALIDATION ********
  const validation = Yup.object().shape({
    unFilledVacancy: Yup.array().of(
      Yup.object().shape({
        firstYearCq: Yup.string().required("Required"),
        secondYearCq: Yup.string().required("Required"),
        thirdYearCq: Yup.string().required("Required"),
        fourthYearCq: Yup.string().required("Required"),
        firstYearMq: Yup.string().required("Required"),
        secondYearMq: Yup.string().required("Required"),
        thirdYearMq: Yup.string().required("Required"),
        fourthYearMq: Yup.string().required("Required"),
      }),
    ),
  });

  // ******** FORMIK ********
  const admissionFormik = useFormik({
    initialValues: {
      unFilledVacancy: [],
    },
    validationSchema: validation,
    onSubmit: (values) => {
      Swal.fire({
        title: "Are you sure?",
        text: "Do you want to Save ?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
      }).then((result) => {
        if (result.isConfirmed) {
          const payload = {
            collegeCourseIntakeList: values.unFilledVacancy.map((item) => ({
              courseId: parseInt(item.courseId),
              sanctionIntake: parseInt(item.sanctionIntake),
              firstYearCq: parseInt(item.firstYearCq),
              secondYearCq: parseInt(item.secondYearCq),
              thirdYearCq: parseInt(item.thirdYearCq),
              fourthYearCq: parseInt(item.fourthYearCq),
              firstYearMq: parseInt(item.firstYearMq),
              secondYearMq: parseInt(item.secondYearMq),
              thirdYearMq: parseInt(item.thirdYearMq),
              fourthYearMq: parseInt(item.fourthYearMq),
            })),
          };
          const url = `${config.url.STU_URL}saveStutcollegecourses`;
          CommonAxiosPost(url, payload)
            .then((res) => {
              if (res?.data?.scode === "01") {
                Swal.fire({
                  title: res.data.sdesc || "Saved!",
                  icon: "success",
                }).then(() => {
                  LoadData();
                });
              } else {
                Swal.fire({
                  text: res.data?.sdesc || "Failed to save details",
                  icon: "warning",
                });
              }
            })
            .catch((err) => {
              console.error(err);
              Swal.fire({
                text: "An error occurred during submission.",
                icon: "error",
              });
            });
        }
      });
    },
  });

  // ******** LOAD DATA ********
  function LoadData() {
    // -------- COURSE DATA --------
    let courseUrl = `${config.url.STU_URL}getcollegecoursresintake/${collCode}`;
    CommonAxiosGet(courseUrl).then((courseRes) => {
      let courses = [];
      if (courseRes?.data?.status === true) {
        setCourseData(true);
        courses = courseRes?.data?.colleges || [];
      }


      // -------- ADMISSION DATA (Submitted Vacancies) --------
      let admissionUrl = `${config.url.STU_URL}getcoursesbycollegeintakesubmit/${collCode}`;
      CommonAxiosGet(admissionUrl).then((admissionRes) => {
        let submittedData = [];
        if (admissionRes?.data?.status === true) {
          setAdmissionData(true);
          submittedData = admissionRes?.data?.college_courses_intake || [];
        }

        // -------- MERGE --------
        const mappedData = courses.map((course) => {
          const existingData = submittedData.find((item) => String(item.course_id) === String(course.course_id) || String(item.courseId) === String(course.course_id));
          return {
            courseId: course.course_id,
            courseName: course.course_name,
            courseCategory: course.course_cat_name,
            sanctionIntake: course.final_sanction_intake,
            academicYear: "2026-2027",
            firstYearCq: existingData ? existingData.firstYearCq || existingData.first_year_cq || "-" : "",
            secondYearCq: existingData ? existingData.secondYearCq || existingData.second_year_cq || "-" : "",
            thirdYearCq: existingData ? existingData.thirdYearCq || existingData.third_year_cq || "-" : "",
            fourthYearCq: existingData ? existingData.fourthYearCq || existingData.fourth_year_cq || "-" : "",
            firstYearMq: existingData ? existingData.firstYearMq || existingData.first_year_mq || "-" : "",
            secondYearMq: existingData ? existingData.secondYearMq || existingData.second_year_mq || "-" : "",
            thirdYearMq: existingData ? existingData.thirdYearMq || existingData.third_year_mq || "-" : "",
            fourthYearMq: existingData ? existingData.fourthYearMq || existingData.fourth_year_mq || "-" : "",
          };
        });
        // Always set rows
        admissionFormik.setFieldValue("unFilledVacancy", mappedData);
      });
    });
  }

  // ******** LOAD ON START ********
  useEffect(() => {
    LoadData();
  }, []);

  return (
    <div className="faculty-form-wrapper">
      <div className="faculty-card">
        <CommonCardHeader title="Entry Of Admission Data" />
        <p className="text-muted mb-2 mt-2" style={{ fontSize: "15px" }}>
          Enter unfilled vacancies for each course
        </p>
        <div className="mt-2">
          <span className="badge bg-primary me-2 px-3 py-2" style={{ fontSize: "13px", fontWeight: "500" }}>
            CQ
          </span>
          <span className="text-dark fw-semibold me-3" style={{ fontSize: "14px" }}>
            Convenor Quota
          </span>
          <span className="badge bg-success me-2 px-3 py-2" style={{ fontSize: "13px", fontWeight: "500" }}>
            MQ
          </span>
          <span className="text-dark fw-semibold" style={{ fontSize: "14px" }}>
            Management Quota
          </span>
        </div>

        <FormikProvider value={admissionFormik}>
          <Form onSubmit={admissionFormik.handleSubmit} className="affl-form">
            {courseData ? (
              <>
                <div className="table-responsive mt-3">
                  <table className="table table-bordered mt-2">
                    <thead className="table-primary">
                      <tr>
                        <th style={{ width: "5%", backgroundColor: "#477053", color: "white" }} rowSpan={3}>
                          S.No
                        </th>
                        <th style={{ width: "12%", backgroundColor: "#477053", color: "white" }} rowSpan={3}>
                          Course Category
                        </th>
                        <th style={{ width: "15%", backgroundColor: "#477053", color: "white" }} rowSpan={3}>
                          Course Name
                        </th>
                        <th style={{ width: "10%", backgroundColor: "#477053", color: "white" }} rowSpan={3}>
                          Academic Year
                        </th>
                        <th style={{ width: "8%", backgroundColor: "#477053", color: "white" }} rowSpan={3}>
                          Intake
                        </th>
                        <th style={{ backgroundColor: "#477053", color: "white", textAlign: "center" }} colSpan={8}>
                          Un Filled vacancies
                        </th>
                      </tr>
                      <tr>
                        <th style={{ backgroundColor: "#477053", color: "white", textAlign: "center" }} colSpan={2}>
                          I Year
                        </th>
                        <th style={{ backgroundColor: "#477053", color: "white", textAlign: "center" }} colSpan={2}>
                          II Year
                        </th>
                        <th style={{ backgroundColor: "#477053", color: "white", textAlign: "center" }} colSpan={2}>
                          III Year
                        </th>
                        <th style={{ backgroundColor: "#477053", color: "white" }} colSpan={2}>
                          IV Year
                        </th>
                      </tr>
                      <tr>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>CQ</th>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>MQ</th>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>CQ</th>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>MQ</th>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>CQ</th>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>MQ</th>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>CQ</th>
                        <th style={{ backgroundColor: "#477053", color: "white" }}>MQ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {admissionFormik.values.unFilledVacancy.map((row, index) => (
                        <tr key={row.courseId || index}>
                          <td>{index + 1}</td>
                          <td>
                            {row.courseCategory}
                            <Field type="hidden" name={`unFilledVacancy[${index}].courseCategory`} />
                          </td>
                          <td>
                            {row.courseName}
                            <Field type="hidden" name={`unFilledVacancy[${index}].courseId`} />
                            <Field type="hidden" name={`unFilledVacancy[${index}].courseName`} />
                          </td>
                          <td>
                            {row.academicYear}
                            <Field type="hidden" name={`unFilledVacancy[${index}].academicYear`} />
                          </td>
                          <td>
                            {row.sanctionIntake}
                            <Field type="hidden" name={`unFilledVacancy[${index}].sanctionIntake`} />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].firstYearCq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].firstYearCq`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].firstYearMq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].firstYearMq`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].secondYearCq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].secondYearCq`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].secondYearMq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].secondYearMq`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].thirdYearCq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].thirdYearCq`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].thirdYearMq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].thirdYearMq`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].fourthYearCq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].fourthYearCq`} component="div" className="text-danger small" />
                          </td>
                          <td>
                            <Field type="text" className="form-control" name={`unFilledVacancy[${index}].fourthYearMq`} onKeyPress={allowNumbersOnly} disabled={admissionData} maxLength="5" />
                            <ErrorMessage name={`unFilledVacancy[${index}].fourthYearMq`} component="div" className="text-danger small" />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {!admissionData ? (
                  <button type="submit" className="btn btn-primary float-end mt-3">
                    Submit
                  </button>
                ) : (
                  <div className="d-flex justify-content-end mt-4">
                    <span className="text-success fw-bold">  ✓ Already Submitted</span>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center text-danger fw-bold fs-6">**** No Data Found ****</div>
            )}
          </Form>
        </FormikProvider>
      </div>{" "}
    </div>
  );
}
